// extracted by mini-css-extract-plugin
module.exports = {"icon":"BadgeTagContainer-icon-e0a7c44cfae57390256aaf01982da4e9","tag":"BadgeTagContainer-tag-fb3ca2c80420353026db622b0eff4709"};